import { providerPreLimitValues } from './provider-pre-limit-values';
export var hasUserZeroPreLimit = function (merchantResponseData, provider) {
    var preLimitValues = providerPreLimitValues(merchantResponseData, provider);
    return preLimitValues ? preLimitValues.max <= 0 : false;
};
